<!--
 * @Description: 不通过
 * @Date: 2021-06-28 18:44:27
-->
<template>
  <el-dialog
    title="审核不通过"
    width="800px"
    :close-on-click-modal="false"
    :visible="true"
    :before-close="close"
  >
    <div class="reject">
      <div class="reject__content">
        <div class="text-area">
          <el-input
            style="width:400px"
            type="textarea"
            :autosize="{
              minRows: 15
            }"
            :maxlength="200"
            :show-word-limit="true"
            placeholder="请输入批注(您可以点击下方内容进行快捷回复)"
            v-model.trim="textarea"
          ></el-input>
        </div>
        <div class="select-area" style="overflow-y: scroll">
          <ol>
            <li>
              <h2>请选择快捷批注内容</h2>
            </li>
            <draggable
              ghost-class="draggable__ghost"
              :handle="`.${DragButtonClassName}`"
              chosen-class="draggable__chosen"
              forceFallback="true"
              fallbackClass="draggable__fallbackClass"
              animation="1000"
              itemKey="id"
              v-model="textArray"
              @start="draggableStart"
              @end="draggableEnd"
              :move="draggableMove"
            >
              <li
                class="select-text"
                v-for="(item, index) in textArray"
                :key="index"
                @click="textarea += item.content"
              >
                <div style="display: flex;align-items: center;width: 80%">
                  <div>
                    <span>{{ index + 1 }}.{{ item.content }}</span>
                  </div>
                </div>
                <div
                  style="width: 20%;display: flex; align-items: center;justify-content: space-around;"
                >
                  <div>
                    <el-tooltip
                      effect="light"
                      content="长按拖拽排序 "
                      placement="top"
                    >
                      <div
                        :class="DragButtonClassName"
                        link
                        type="text"
                        style="color:red;cursor:grab"
                      >
                        <i class="el-icon-rank"></i>
                      </div>
                    </el-tooltip>
                  </div>
                  <div>
                    <el-button
                      type="text"
                      link
                      @click.stop="send('remove', { id: item.id })"
                      style="color:red;width: 50px"
                    >
                      ✖
                    </el-button>
                  </div>
                </div>
              </li>
            </draggable>
          </ol>
        </div>
      </div>

      <div class="footer custom-footer-btn">
        <el-button
          :disabled="!textarea"
          @click="confirm(1)"
          type="primary"
          plain
        >
          提交并加入快捷回复
        </el-button>
        <el-button
          :disabled="!textarea"
          @click="confirm(0)"
          type="primary"
          plain
        >
          仅提交
        </el-button>
        <!--      <el-button @click="send('zuofei')" type="primary" plain>作废</el-button>-->
        <el-button @click="close" type="primary" plain>关闭</el-button>
        <!--      <el-button type="primary" @click="confirm">确 定</el-button>-->
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { fastReply } from '../api';
import draggable from 'vuedraggable';
export default {
  components: {
    draggable
  },
  data() {
    return {
      DragButtonClassName: 'drag-button-class',
      dialogVisibleReject: false,
      textarea: '',
      oldTextArray: [],
      textArray: []
    };
  },
  methods: {
    draggableMove() {
      return true;
    },
    draggableStart() {
      this.oldTextArray = [...this.textArray];
    },
    async draggableEnd() {
      try {
        await fastReply.sorting(this.textArray.map(i => i.id));
      } catch (error) {
        this.textArray = this.oldTextArray;
      }
    },
    async send(type, param) {
      if (type === 'remove') {
        await this.$confirm('是否删除快捷回复');
        await fastReply.delete(param);
        await this.queryData();
      }
    },
    // type 1提交并保存信息 0仅提交
    confirm(type) {
      this.$emit('confirm', { textarea: this.textarea, type });
    },
    async close() {
      this.$emit('close');
    },
    async queryData() {
      const {
        projectId,
        csoEnterpriseId: enterpriseId // TODO: 后端未完成，待修改
      } = this.$store.state.dataAnalysis.projectDetail;

      const { data } = await fastReply.get({
        projectId,
        enterpriseId
      });
      this.textArray = [...data['data']];
    }
  },
  async created() {
    await this.queryData();
  }
};
</script>
<style lang="scss" scoped>
.reject {
  width: 700px;
  &__content {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
}
.select-area {
  text-align: left;
  .select-text {
    margin-top: 23px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
    display: flex;
    justify-content: space-between;
    user-select: none;
  }
  .select-text:hover {
    background-color: #fff;
    cursor: pointer;
  }
  width: 280px;
  padding: 20px;
  height: 336px;
  background: #f5f7fa;
  border-radius: 2px;
  opacity: 0.99;
}
.footer {
  text-align: right;
  margin-top: 30px;
}
::v-deep {
  .custom-footer-btn {
    .el-textarea.is-disabled,
    .is-disabled,
    .el-textarea__inner {
      cursor: not-allowed !important;
    }
  }
}
</style>
